'use strict';

export default angular.module('contartemx.clientes', [
  'ui.router'
])
  .config(['$stateProvider', ($stateProvider) => {

    $stateProvider.state('clientes', {
      url: '/Clientes',
      abstract: true,
      views:
      {
        'submenu': {
          template: require('../../../../app/views/Clientes/Clientes_submenu.html'),
          controller: 'ClientesCtrl'
        },
        '': {
          template: require('../../../../app/views/MainContainer.html'),
          controller: 'ClientesCtrl'
        }
      },
      resolve: {
        authorize: ['authorization', authorization => authorization.authorize()],
        contartemxClientes: ($q, $ocLazyLoad) => {
          return import(
            /* webpackChunkName: "clientes" */
            './clientes'
          ).then(module => $ocLazyLoad.inject(module.default));
        }
      },
      data: { roles: ['Clientes'] }
    })
      .state('clientes.ventas_servicios', {
        url: '/VentasServicios',
        views:
        {
          'main': {
            template: require('../../../../app/views/Clientes/Ventas_Servicios/templates/VentasServicios_main.html'),
            controller: 'VentasServiciosCtrl'
          }
        },
        data: { roles: ['Clientes_VentasYServicios'] }
      })
      .state('clientes.ventas_servicios.nueva_venta', {
        url: '/Nuevo/:type?cveCliente',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Ventas_Servicios/Nueva_Venta/NuevaVenta_main.html'),
            controller: 'NuevaVentaCtrl'
          }
        },
        data: { roles: ['Clientes_Facturacion', 'Clientes_NotasDeIngreso',] }
      })
      .state('clientes.ventas_servicios.sustitucion', {
        url: '/Sustitucion/:cveTransaccion',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Ventas_Servicios/Nueva_Venta/NuevaVenta_main.html'),
            controller: 'NuevaVentaCtrl'
          }
        },
        params: {
          type: 'factura'
        },
        data: { roles: ['Clientes_Facturacion', 'Clientes_NotasDeIngreso',] }
      })
      .state('clientes.ventas_servicios.ver_venta', {
        url: '/Venta/:num_venta',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/Views/Clientes/Ventas_Servicios/Ver_Venta/VerVenta_main.html'),
            controller: 'VerVentaCtrl'
          }
        },
        data: { roles: ['Clientes_VentasYServicios', 'Clientes_Facturacion', 'Clientes_NotasDeIngreso',] }
      })
      .state('clientes.cobros', {
        url: '/Cobros',
        abstract: true,
        views:
        {
          'main': {
            template: require('../../../../app/views/Clientes/Cobros/templates/Cobros_main.html'),
            controller: 'CobrosCtrl',
          }
        },
        data: { roles: ['Clientes_Cobros'] }
      })
      .state('clientes.cobros.cronologia', {
        url: '/Lista',
        template: require('../../../../app/views/Clientes/Cobros/templates/Cobros_lista.html'),
        controller: 'CobrosListaCtrl',
        data: { roles: ['Clientes_SoloCobros'] }

      })
      .state('clientes.cobros.complementos_pago', {
        url: '/ComplementosPago',
        template: require('../../../../app/views/ComplementosPago/ComplementosPago.html'),
        controller: 'ComplementosPagoCtrl',
        data: { roles: ['Clientes_ComplementosDePago'] }
      })
      .state('clientes.cobros.nuevo_cobro', {
        url: '/Nuevo/:cveTrans',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Cobros/Nuevo_Cobro/NuevoCobro_main.html'),
            controller: 'NuevoCobroCtrl',
          }
        },
        data: { roles: ['Clientes_SoloCobros', 'Clientes_ComplementosDePago'] }
      })
      .state('clientes.cobros.cancelacion_rep', {
        url: '/CancelacionREP/:cveTrans',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Cobros/Nuevo_Cobro/NuevoCobro_main.html'),
            controller: 'NuevoCobroCtrl',
          }
        },
        params: {
          CveCobro: null
        },
        data: { roles: ['Clientes_SoloCobros', 'Clientes_ComplementosDePago'] }
      })
      .state('clientes.cobros.multiples', {
        url: '/CobrosMultiples/:cveTrans',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Cobros/CobrosMultiples.html'),
            controller: 'cobrosMultiplesCtrl'
          }
        },
        params: {
          cveTrans: null
        },
        data: { roles: ['Clientes_SoloCobros', 'Clientes_ComplementosDePago'] }
      })
      .state('clientes.notas_credito', {
        url: '/NotaCredito',
        abstract: true,
        data: { roles: ['Clientes_NotasDeCredito'] }
      })
      .state('clientes.notas_credito.nueva_nota_credito', {
        url: '/Nuevo/:cveTrans',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Cobros/Nuevo_Cobro/NuevoCobro_main.html'),
            controller: 'NuevoCobroCtrl'
          }
        },
        data: { roles: ['Clientes_NotasDeCredito'] }
      })
      .state('clientes.directorio', {
        url: '/Directorio',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Directorio/templates/Directorio_main.html'),
            controller: 'ClientDirectorioCtrl'
          }
        },
        data: { roles: ['Clientes_Directorio'] }
      })
      .state('clientes.directorio.perfil_cliente', {
        url: '/:cveCuentaCliente',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Directorio/PerfilCliente_main.html'),
            controller: 'PerfilClienteCtrl'
          }
        },
        data: { roles: ['Clientes_Directorio'] }
      })
      .state('clientes.articulos', {
        url: '/Articulos',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Articulos/templates/Articulos_main.html'),
            controller: 'ArticulosCtrl'
          }
        },
        data: { roles: ['Clientes_Articulos'] }
      })
      .state('clientes.articulos.perfil_articulo', {
        url: '/:cveCuentaArticulo',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Articulos/PerfilArticulo_main.html'),
            controller: 'PerfilArticuloCtrl'
          }
        },
        data: { roles: ['Clientes_Articulos'] }
      })

      .state('clientes.plantilla', {
        url: '/Plantilla',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Recurrentes/Plantilla_main.html'),
            controller: 'PlantillaCtrl'
          }
        },
        data: { roles: ['Clientes_Articulos'] }
      })

      .state('clientes.ventas_recurrentes', {
        url: '/VentasRecurrentes',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Recurrentes/Recurrentes_main.html'),
            controller: 'RecurrentesCtrl'
          }
        },
        data: { roles: ['Clientes_VentasYServicios'] }
      })
      .state('clientes.ventas_recurrentes.ver_venta', {
        url: '/:num_venta',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Recurrentes/Ver_Recurrente.html'),
            controller: 'VerRecurrenteCtrl'
          }
        },
        data: { roles: ['Clientes_Facturacion', 'Clientes_NotasDeIngreso',] }
      })
      .state('clientes.ventas_recurrentes.nuevo', {
        url: '/Nuevo/:type?cveCliente',
        views:
        {
          'main@clientes': {
            template: require('../../../../app/views/Clientes/Recurrentes/Nueva_Recurrente.html'),
            controller: 'NuevaRecurrenteCtrl'
          }
        },
        data: { roles: ['Clientes_Facturacion', 'Clientes_NotasDeIngreso',] }
      });

  }])

  .controller('ClientesCtrl', () => {

  });

